export var Text = {
  baseStyle: {
    letterSpacing: '-0.2px'
  },
  sizes: {
    xs: {
      fontWeight: 'semibold',
      lineHeight: '1rem'
    }
  }
};